import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';
import { useViewer } from '@/features/session';
import { firstUserErrorCode } from '@/graphql/errors';
import { START_TEST_POD } from '@/graphql/mutations/test-pod';
import { track } from '@/shared/lib/analytics';

type UseStartTestPodResult = {
  startTestPod: () => Promise<{ errorCode: string | null }>;
  isStarting: boolean;
};

export function useStartTestPod(): UseStartTestPodResult {
  const { refreshViewer } = useViewer();
  const [mutate, { loading }] = useMutation(START_TEST_POD);

  const startTestPod = useCallback(async () => {
    const { data } = await mutate();
    const errorCode = firstUserErrorCode(data?.startTestPod.userErrors);
    track('test_pod_started', { error_code: errorCode });
    await refreshViewer();
    return { errorCode };
  }, [mutate, refreshViewer]);

  return { startTestPod, isStarting: loading };
}
